import { useEffect, useState, useCallback } from   'react';
import SeccionPageHeader from "./../Utils/SeccionPageHeader";
import CargandoSpinner from "./../Utils/CargandoSpinner";
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService';
import { useAuth } from './../../Auth/AuthContext';

export default function MenuAlbergue() {
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    return (
        <div className="content-wrapper">
             <SeccionPageHeader
                title="Albergues"
                idCabezaFamilia="0"
                url="/"
                nombreurl=""
                nombreform="Albergues"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="menu-ahe-buttons" style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
                    <a
                        href="/albergues/albergue/0"
                        data-tooltip-id="tooltiparriba"
                        data-tooltip-content="Registrar atencion albergue"
                        className="btn btn-primary"
                        type="button"
                    >
                        Registrar atencion albergue
                    </a>
                    <a
                        href="/albergues/Registroalbergue/0/0"
                        data-tooltip-id="tooltiparriba"
                        data-tooltip-content="Registro albergue"
                        className="btn btn-primary"
                        type="button"
                    >
                        Registro albergue
                    </a>
                    <a
                        href="/albergues/permanenciaalbergue"
                        data-tooltip-id="tooltiparriba"
                        data-tooltip-content="Permanencia albergues"
                        className="btn btn-primary"
                        type="button"
                    >
                        Permanencia albergue
                    </a>
                </div>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}